import script from "./EventAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./EventAlerts.vue?vue&type=script&setup=true&lang=js"

import "./EventAlerts.vue?vue&type=style&index=0&id=ca7657b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca7657b6"]])

export default __exports__